import services from './../../../services/service'; // Service Class
import MainHeader from './../../MainHeader/index.vue'; // Main Header
import MainFooter from './../../MainFooter/index.vue'; // Main Footer
import MainSidebar from './../../MainSidebar/index.vue'; // Main Sidebar
import ProductList from '../../../components/product/ProductList.vue'
import RightSidebar from './../../../components/templates/rightsidebar.vue'; 
import LeftSidebar from './../../../components/templates/leftsidebar.vue'; 
import SearchBox from './../../../components/templates/searchbox.vue'; 

let service = new services();

export default {
    name: 'Home',
    data () {
        return {
            user:{},
            products: {},
            product: {},
            search_words:"",
            search_type:"business",
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true
        }
    },
  
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
        'component-sidebar': MainSidebar,
        'right-sidebar': RightSidebar,
        'left-sidebar': LeftSidebar,
        'search-box': SearchBox,
    },
    computed: {
        total() {
          var total = 0;
          for(var i = 0; i < this.items.length; i++) {
            total += this.items[i].product_price;
          }
          return total;
        }
    },
    methods: {
        preset() {
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                           this.user.user_id = element.user_id;
                           this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                        }, this);
                    }else {
                       //this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                        //this.$router.push('login');
                    }
                })
            }else {
               //this.$router.push('login');
            }
        },

        search(){
            this.$router.push("search?search="+this.search_type+"&k="+this.search_words)
        },
     
        setProducts(){ 
           this.getProducts(0,20);
                    
        },
        
        // getProducts(){
        //     let offset = 45; let limit = 20;
        //     service.getProducts(this,offset,limit).then(response => {
        //         if(response.body.status == 200) {
        //             this.products = response.body.data;
        //         }else{
        //             //reloop fake
        //             service.getProducts(this,offset,limit).then(response => {
        //                 if(response.body.status == 200) {
        //                     this.products = response.body.data;
        //                 }
        //             }).catch((err) => {})
        //         }
        //     }).catch((err) => {})
            
        // },


        getMarketActivityProducts(){
            let offset = 0; let limit = 20;
            service.getMarketActivityProducts(this,service.market_app_name,offset,limit).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data;
                    this.loading = false;
                }
            }).catch((err) => {})
                
        },
        
    },
    created: function(){
        this.preset();
        this.getMarketActivityProducts();
    }
}


// WEBPACK FOOTER //
// ./src/pages/Adminpoint/Events/script.js